import PlansPage from './PlansPage';

export default PlansPage;
